
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-saved-indikator',
  templateUrl: './saved-indikator.component.html',
  styleUrls: ['./saved-indikator.component.css'],
  imports: [],
  standalone: true
})
export class SavedIndikatorComponent {
  @Input() isSaved: boolean;
}